/**
 * KAN-980: вкладка "Кабинеты": все организации платформы с тарифом, балансом,
 * числом пользователей и Telegram-аккаунтов; ручная корректировка кошелька.
 */
import { useState } from 'react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { usePlatformOrganizations } from '@/hooks/usePlatform';
import { modeLabels } from '@/lib/modeLabels';
import { formatRub } from '@/lib/wallet';
import type { PlatformOrganization } from '@/services/api/platform';
import type { OrganizationMode } from '@/types/settings';
import { WalletDialog } from './WalletDialog';

const modeName = (mode: string): string =>
  mode === 'ecommerce' || mode === 'estimator' ? modeLabels(mode as OrganizationMode).modeName : mode || '-';

export function CabinetsTab() {
  const { data, isLoading, isError } = usePlatformOrganizations();
  const [walletOrg, setWalletOrg] = useState<PlatformOrganization | null>(null);

  if (isLoading) return <p className="text-sm text-gray-500">Загрузка...</p>;
  if (isError) {
    return (
      <p role="alert" className="text-sm text-red-600">
        Не удалось загрузить кабинеты
      </p>
    );
  }

  return (
    <>
      <div className="overflow-x-auto rounded-lg bg-white shadow">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Кабинет</TableHead>
              <TableHead>Режим</TableHead>
              <TableHead>Тариф</TableHead>
              <TableHead className="text-right">Баланс</TableHead>
              <TableHead className="text-right">Пользователей</TableHead>
              <TableHead className="text-right">Аккаунтов TG</TableHead>
              <TableHead className="text-right">Здоровых</TableHead>
              <TableHead className="text-right">Подключено</TableHead>
              <TableHead className="text-right">Были под флудом</TableHead>
              <TableHead />
            </TableRow>
          </TableHeader>
          <TableBody>
            {(data ?? []).map((org) => (
              <TableRow key={org.id} data-testid="platform-org-row">
                <TableCell className="font-medium">
                  <span>{org.name}</span>
                  {org.is_pool && (
                    <Badge variant="processing" className="ml-2">
                      Пул
                    </Badge>
                  )}
                </TableCell>
                <TableCell>{modeName(org.mode)}</TableCell>
                <TableCell>{org.plan_name ?? '-'}</TableCell>
                <TableCell className="whitespace-nowrap text-right">{formatRub(org.balance)}</TableCell>
                <TableCell className="text-right">{org.users_count}</TableCell>
                <TableCell className="text-right">{org.telegram_accounts_count}</TableCell>
                <TableCell className="text-right">{org.telegram_accounts_healthy ?? 0}</TableCell>
                <TableCell className="text-right">{org.telegram_accounts_connected ?? 0}</TableCell>
                <TableCell className="text-right">{org.telegram_accounts_flooded ?? 0}</TableCell>
                <TableCell className="text-right">
                  <Button
                    size="sm"
                    variant="outline"
                    data-testid="platform-wallet-open"
                    onClick={() => setWalletOrg(org)}
                  >
                    Начислить / списать
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <WalletDialog organization={walletOrg} onClose={() => setWalletOrg(null)} />
    </>
  );
}
